import { AxiosPromise } from "axios";

import api from "../config/api-config";

export function getInventory(): AxiosPromise {
  return api.get("v1/inventories", {});
}

export function postInventory(obj: any): AxiosPromise {
  return api.post("v1/inventories", obj, {});
}

export function putInventory(obj: any, id: any): AxiosPromise {
  return api.put("v1/inventories/" + id, obj, {});
}

export function deleteInventory(id: number): AxiosPromise {
  return api.delete("v1/inventories/" + id);
}

export function getInventoryHistoric(): AxiosPromise {
  return api.get("v1/inventories/logs", {});
}

export default {
  getInventory,
  postInventory,
  putInventory,
  deleteInventory,
  getInventoryHistoric,
};
